import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductCreate from "../Pages/Products/ProductCreate";
import InviteSubscriber from "../Pages/Subscriptions/Invitation/InviteSubscriber";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import BusinessCustomersActions from "../Redux/transition/customers/business-customer.reducer";
import PaymentTrackActions from "../Redux/transition/payment-track/payment-track.reducer";
import { useNavigate } from "react-router-dom";
import OnboardingNotification from "../Components/OnboardingNotification";
import { GlobalSearch } from "./GlobalSearch";
import { CreateSubscriberDialog } from "../Pages/Subscriptions/Invitation/InviteComponents/CreateSubscriberDialog";
import { isLiveCollectionReady } from "../utils/pspOnboarding";

export function ActionButtons(visible, defMembership, toogleInviteSubscriber, onHide, onHidePlan, tooglePlan, visiblePlan, business, paymentCredentials, toogleShareBusiness) {

    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const signingPending = useSelector((state) => state.documents.signingPending);
    const credentials = useSelector((state) => state.payswitch.credentials);
    const liveReady = isLiveCollectionReady({
        business,
        credentials,
        paymentCredentials,
        signingPending,
    });
    const [openNotification, setOpenNotification] = useState(false);
    const [visibleCreateSubscriber, setVisibleCreateSubscriber] = useState(false);

    const [visibleInvite, setVisibleInvite] = useState(false);
    const [state, setState] = useState({
        filteredCustomers: [],
        exactFilteredBusinessCustomers: [],
        selectedCustomerId: null,
        isCustomerSelected: false,
        verificationStatus: null,
        fetchingVerifRecord: true,
        query: ""
    });

    const dispatch = useDispatch();
    const getEnterpriseCustomers = useCallback((businessId) => dispatch(BusinessCustomersActions.businessCustomerRecordRequest(businessId)), [dispatch]);
    const getBusinessCustomerSubscriptions = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.businessCustomerSubscriptionsRequest(businessCustomerId)), [dispatch]);
    const getBusinessCustomerRecord = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.businessCustomerRecordRequest(businessCustomerId)), [dispatch]);
    const getRecentCustomerPayments = useCallback((businessCustomerId, size) => dispatch(BusinessCustomersActions.businessCustomerPaymentsRequest(businessCustomerId, size)), [dispatch]);
    const getRecentMissedCustomerPayments = useCallback((businessCustomerId, size) => dispatch(BusinessCustomersActions.businessCustomerMissedPaymentsRequest(businessCustomerId, size)), [dispatch]);
    const getRecentSubscriptionActivity = useCallback((businessCustomerId, size) => dispatch(BusinessCustomersActions.businessCustomerSubscriptionActivityRequest(businessCustomerId, size)), [dispatch]);
    const getCustomerPendingPayments = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.customerPendingPaymentRequest(businessCustomerId)), [dispatch]);
    const getCustomerMissedPayments = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.customerMissedPaymentRequest(businessCustomerId)), [dispatch]);
    const getCustomerReceivedPayments = useCallback((businessCustomerId) => dispatch(BusinessCustomersActions.customerReceivedPaymentRequest(businessCustomerId)), [dispatch]);
    const getSuccessfulPayments = useCallback((bcId) => { dispatch(BusinessCustomersActions.successfulPaymentsRequest(bcId)) }, [dispatch])
    const getExpiredPayments = useCallback((bcId) => { dispatch(BusinessCustomersActions.expiredPaymentsRequest(bcId)) }, [dispatch])
    const getBusinessCustomerExternalPayments = useCallback((businessId, bcId) => { dispatch(PaymentTrackActions.businessCustomerExternalPaymentsRequest(businessId, bcId)) }, [dispatch])

    const exactFilteredBusinessCustomers = useSelector((state) => state.businessCustomers.exactFilteredBusinessCustomers);

    //Toggle merchant onboarding onhide
    const toggleSetOpenDialog = () => { setOpenNotification(!openNotification) };

    useEffect(() => {
        if (exactFilteredBusinessCustomers) {
            setState((state) => {
                return { ...state, exactFilteredBusinessCustomers: exactFilteredBusinessCustomers };
            });
        }
        if (state.isCustomerSelected) {
            const customerId = state.selectedCustomerId
            navigate(`/crm/customers/customer/${customerId}`)
            getEnterpriseCustomers(state.selectedCustomerId)
            getBusinessCustomerSubscriptions(state.selectedCustomerId)
            getBusinessCustomerRecord(state.selectedCustomerId)
            getRecentCustomerPayments(state.selectedCustomerId, "3")
            getRecentMissedCustomerPayments(state.selectedCustomerId, "3")
            getRecentSubscriptionActivity(state.selectedCustomerId, "3")
            getCustomerPendingPayments(state.selectedCustomerId)
            getCustomerMissedPayments(state.selectedCustomerId)
            getCustomerReceivedPayments(state.selectedCustomerId)
            getSuccessfulPayments(state.selectedCustomerId)
            getExpiredPayments(state.selectedCustomerId)
            getBusinessCustomerExternalPayments(defMembership.business.id, state.selectedCustomerId)
            setState((state) => { return { ...state, isCustomerSelected: false } })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [exactFilteredBusinessCustomers, state.isCustomerSelected, state.selectedCustomerId, navigate]);

    const toggleInvite = () => {
        setVisibleInvite(!visibleInvite)
    }

    return <div style={{ backgroundColor: "#FFFFFF" }}>
        <OnboardingNotification visible={openNotification} onHide={toggleSetOpenDialog} />
        <span><ProductCreate visiblePlan={visiblePlan} onHide={() => { onHidePlan(); }} /> </span>
        <InviteSubscriber visible={visible} toggleVisible={visibleInvite} setVisibleInvite={setVisibleInvite} onHide={toggleInvite} initialTier={null} />
        <CreateSubscriberDialog
            visible={visibleCreateSubscriber}
            onHide={() => setVisibleCreateSubscriber(false)}
            businessId={defMembership?.business?.id}
            defMembership={defMembership}
            defaultCountry="GH"
        />
        <>
            <div className="main_div_action_btns">
                <div className="action-bar-global-search">
                    <GlobalSearch
                        defMembership={defMembership}
                        state={state}
                        setState={setState}
                        globalQuery={true}
                    />
                </div>

                <div className="action-bar-buttons">
                    <Button
                        className="actionBar_btns"
                        label={t("business.business_link")}
                        onClick={() => {
                            if (!liveReady) {
                                toogleShareBusiness()
                            } else if (!paymentCredentials?.value && !business?.customPmtProvider) {
                                setOpenNotification(true)
                            }
                            else {
                                navigate("/share/business")
                            }
                        }}
                    />
                    <Button
                        className="actionBar_btns"
                        label={t("invitation.invite_subscriber")}
                        onClick={() => {
                            if (defMembership) {
                                if (!liveReady) {
                                    toogleShareBusiness()
                                }
                                else if ((!state.verifStatus && !state.fetchingVerifRecord && !business?.customPmtProvider)) {
                                    setOpenNotification(true)
                                } else {
                                    setVisibleInvite(true)
                                }
                            }
                            else {
                                toogleShareBusiness()
                            }
                        }}
                    />
                    <Button
                        className="actionBar_btns"
                        label={t("business_customers.create_subscriber")}
                        onClick={() => setVisibleCreateSubscriber(true)}
                    />
                    {((defMembership?.role === "OWNER") || (defMembership?.role === "ADMIN")) && (
                        <Button
                            className="actionBar_btns"
                            id="create_group"
                            label={t("products.create_group")}
                            disabled={!defMembership}
                            onClick={tooglePlan}
                        />
                    )}
                </div>
            </div>
        </>
    </div>;
}